// O CATÁLOGO DAS NOVIDADES (22/10/2026) — um lugar só para o modal, o megafone e a página de Novidades.
//
// Victor: "quero que em notificações apareçam as novidades também, e quando apertado abra uma página contando as
// novidades de forma linda, interativa, intuitiva, com motion graphics… e isso vale para o modal". Antes, cada
// aviso (NovidadeDesfazerEnvio, NovidadeCaixaUnica, NovidadeCopiloto) carregava os próprios prints; a página precisa
// dos mesmos. Novidade nova = uma entrada aqui (a mais nova em cima) e, se tiver modal, um componente Novidade*.vue.
//
//   id       âncora na página (/novidades#copiloto, o megafone leva direto) e chave da cena animada (cenas/)
//   chave    preferência do modal (ModalDeNovidade); null = a novidade só existe na página
//   textos   prefixo das traduções: SELO, TITULO, ABERTURA, PASSO{n}_TIT, PASSO{n}, IA_* (opcional), CTA (opcional)
//   cor      a cor da cena e do selo: 'iris' (IA), 'ambar' (Pendências), 'marca' (conversas)
//   passos   [{ imagem?, alt? }] — um por passo; sem imagem, o passo é só texto (e a cena conta a história)
//   acao     o que "Experimentar" faz: 'lumos' (abre o painel), 'pendencias' (abre a gaveta), 'conversas'
//   publicada (opcional) a hora do lançamento, para a novidade que sai no mesmo dia de outra: quem abriu a página de
//            manhã ainda a vê como nova à tarde. Sem ela, vale o dia (`data`).
const PRINTS = '/assets/images/novidades';

export const NOVIDADES = [
  {
    id: 'balao',
    chave: null,
    data: '2026-10-22',
    publicada: '2026-10-22T12:53:00-03:00',
    textos: 'NOVIDADES.BALAO',
    cor: 'marca',
    icone: 'i-lucide-layers',
    comIa: false,
    acao: 'conversas',
    passos: [
      {
        imagem: `${PRINTS}/balao-1-esperando.webp`,
        alt: 'Duas mensagens seguidas esperando para sair, cada uma com a contagem e o aviso "Vai junto, num balão só"',
      },
      {
        imagem: `${PRINTS}/balao-2-saiu.webp`,
        alt: 'Duas mensagens que já saíram, cada uma com a marca "Saiu num balão só" embaixo',
      },
      {},
    ],
  },
  {
    id: 'retomada',
    chave: null,
    data: '2026-10-22',
    publicada: '2026-10-22T11:40:00-03:00',
    textos: 'NOVIDADES.RETOMADA',
    cor: 'iris',
    icone: 'i-lucide-repeat',
    comIa: true,
    acao: 'pendencias',
    passos: [
      {},
      {
        imagem: `${PRINTS}/retomada-2-pendencias.webp`,
        alt: 'Cartão da retomada nas Pendências: a mensagem que vai sair, a última fala da equipe e os botões Não enviar, Enviar e Abrir a conversa',
      },
      {},
    ],
  },
  {
    id: 'copiloto',
    chave: 'novidade_copiloto_vista',
    data: '2026-10-22',
    textos: 'LUMOS.NOVIDADE',
    cor: 'iris',
    icone: 'i-ph-sparkle-fill',
    comIa: true,
    acao: 'lumos',
    passos: [
      {
        imagem: `${PRINTS}/copiloto-1-processo.webp`,
        alt: 'Pergunta ao Lumos sobre a sentença de um processo e a resposta citando, entre aspas, o trecho do andamento',
      },
      {
        imagem: `${PRINTS}/copiloto-2-tema.webp`,
        alt: 'Pergunta "Quais processos têm perícia marcada?" e a resposta com a lista dos três processos e as datas',
      },
      {
        imagem: `${PRINTS}/copiloto-3-fontes.webp`,
        alt: 'O bloco "De onde veio" embaixo da resposta, com o andamento e a publicação citados, e os botões de avaliar',
      },
    ],
  },
  {
    id: 'bom-dia',
    chave: null,
    data: '2026-10-22',
    textos: 'NOVIDADES.BOM_DIA',
    cor: 'ambar',
    icone: 'i-ph-sun-horizon-fill',
    comIa: false,
    acao: 'pendencias',
    passos: [{}, {}, {}],
  },
  {
    id: 'caixa-unica',
    chave: 'novidade_caixa_unica_vista',
    data: '2026-10-20',
    textos: 'PENDENCIAS.NOVIDADE',
    cor: 'ambar',
    icone: 'i-ph-hand-pointing-fill',
    comIa: true,
    acao: 'pendencias',
    passos: [
      {
        imagem: `${PRINTS}/caixa-unica-1-andamento.webp`,
        alt: 'Cartão de andamento que pede ação: o resumo da IA, o trecho do andamento e os botões Já vi, Criar tarefa e Abrir o processo',
      },
      {
        imagem: `${PRINTS}/caixa-unica-3-mapa.webp`,
        alt: 'O topo das Pendências: um selo por grupo com o número, e o primeiro cartão com o rosto da pessoa',
      },
      {
        imagem: `${PRINTS}/caixa-unica-2-bom-dia.webp`,
        alt: 'O Bom dia das Pendências: a data, o nome da pessoa e os selos do que espera por ela',
      },
    ],
  },
  {
    id: 'desfazer-envio',
    chave: 'novidade_desfazer_envio_vista',
    data: '2026-10-20',
    textos: 'CONVERSATION.NOVIDADE_DESFAZER',
    cor: 'marca',
    icone: 'i-lucide-undo-2',
    comIa: false,
    acao: 'conversas',
    passos: [
      {
        imagem: `${PRINTS}/desfazer-envio-1-desfazer-envio.webp`,
        alt: 'Mensagem recém-enviada com o cartão da contagem e o botão Desfazer embaixo',
      },
      {
        imagem: `${PRINTS}/desfazer-envio-2-envio-desfeito.webp`,
        alt: 'A mesma mensagem riscada, marcada como envio desfeito',
      },
      {
        imagem: `${PRINTS}/desfazer-envio-3-nao-da-para-apagar.webp`,
        alt: 'Aviso de que não dá para apagar pelo advup, com o passo a passo no celular do escritório',
      },
    ],
  },
];

export const novidade = id => NOVIDADES.find(n => n.id === id);

// QUANDO SAIU (22/10/2026, Victor: "vai rolando e vendo quando saiu"): a página é uma linha do tempo e o megafone
// lista as novidades com a data. "Saiu hoje", "Saiu ontem" ou "Saiu em 20 de outubro" — a data do catálogo é do dia
// do lançamento, sem hora.
const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

export const dataLonga = iso => {
  const [, m, d] = iso.split('-').map(Number);
  return `${d} de ${MESES[m - 1]}`;
};

const diaLocal = data =>
  [
    data.getFullYear(),
    String(data.getMonth() + 1).padStart(2, '0'),
    String(data.getDate()).padStart(2, '0'),
  ].join('-');

// Devolve a chave da tradução (em NOVIDADES.PAGINA) e o valor de {data}.
export const quandoSaiu = (iso, agora = new Date()) => {
  const ontem = new Date(agora);
  ontem.setDate(agora.getDate() - 1);
  if (iso === diaLocal(agora)) return { chave: 'SAIU_HOJE', data: '' };
  if (iso === diaLocal(ontem)) return { chave: 'SAIU_ONTEM', data: '' };
  return { chave: 'SAIU_EM', data: dataLonga(iso) };
};

// A linha do tempo: as novidades agrupadas pelo dia em que saíram, na ordem do catálogo (a mais nova em cima).
export const porDia = (lista = NOVIDADES) =>
  lista.reduce((dias, n) => {
    const ultimo = dias[dias.length - 1];
    if (ultimo && ultimo.data === n.data) ultimo.itens.push(n);
    else dias.push({ data: n.data, itens: [n] });
    return dias;
  }, []);

// Quando a pessoa abriu a página de Novidades pela última vez (preferência no servidor, vale em qualquer aparelho).
export const CHAVE_PAGINA_VISTA = 'novidades_pagina_vista_em';

// Nova para a pessoa = saiu depois da última visita à página E ela ainda não viu o modal dela (quando tem modal).
export const ehNova = (n, ui = {}) => {
  const visita = ui[CHAVE_PAGINA_VISTA];
  const visitouDepois = n.publicada
    ? new Date(visita) >= new Date(n.publicada)
    : n.data <= String(visita).slice(0, 10);
  if (visita && visitouDepois) return false;
  const modal = n.chave && ui[n.chave];
  const vistaNoModal =
    modal && (typeof modal === 'object' ? modal.vista_em : modal);
  return !vistaNoModal;
};

export const novasPara = (ui = {}) => NOVIDADES.filter(n => ehNova(n, ui));
